export default __webpack_public_path__ + "img/01.5132b4a4.jpg";